<template>
    <div class="spu-page">
        <!-- 头图区 -->
        <div class="spu-hero">
            <div class="spu-hero-bg">
                <img :src="require('@/assets/img/bg.svg')" alt="">
            </div>
        </div>

        <!-- 内容区 -->
        <div class="spu-body">
            <!-- 介绍文案卡 -->
            <div class="spu-card spu-intro">
                <p class="spu-intro-text">
                    根据大数据多维度选出正处于<em>K线上升趋势</em>，<em>成交量</em>和<em>市场关注度</em>较高，<em>中线热门题材</em>，<em>主流机构</em>和<em>量化资金</em>抱团的活跃股。
                </p>
            </div>

            <!-- 战绩回顾卡 -->
            <div class="spu-card spu-record" v-if="top_list && top_list.length > 0">
                <div class="spu-card-head">
                    <div class="spu-card-title-wrap">
                        <img class="spu-card-icon" :src="iconRecord" alt="" />
                        <span class="spu-card-title">战绩回顾</span>
                        <span class="spu-card-sub">历史业绩不代表未来收益</span>
                    </div>
                    <div class="spu-card-more" @click="onMoreRecord">
                        <span>更多</span>
                        <img class="spu-card-arrow" :src="arrowMore" alt="" />
                    </div>
                </div>
                <!-- 卡内轮播（战绩榜 mock 数据，待接 stock_pool_rank 接口） -->
                <div class="spu-record-list swiper2" >
                    <div class="swiper-container">
                        <div class="swiper-wrapper swiper-no-swiping">
                            <div
                                class="swiper-slide"
                                v-for="(item, i) in top_list"
                                :key="'record_' + i"
                                @click="onClickRecord(item)"
                            >
                                <span class="spu-record-name">{{ item.name }}</span>
                                <span class="spu-record-desc">{{ item.text }}</span>
                                <span class="spu-record-pct" :class="{ down: item.chg < 0 }">{{ item.chg > 0 ? '+' : '' }}{{ Number(item.chg).toFixed(2) }}%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 购买动态卡 -->
            <div class="spu-card spu-dynamic" v-if="dynamic_list.length > 0">
                <img class="spu-card-icon" :src="iconDynamic" alt="" />
                <span class="spu-dynamic-label">购买动态</span>
                <img class="spu-dynamic-divider" :src="dividerDynamic" alt="" />
                <div class="spu-dynamic-list swiper3">
                    <div class="swiper-container">
                        <div class="swiper-wrapper swiper-no-swiping">
                            <div
                                class="swiper-slide"
                                v-for="(item, i) in dynamic_list"
                                :key="'dynamic_' + i"
                            >
                                <span class="spu-dynamic-text">{{ item.text }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 开通套餐卡 -->
            <div class="spu-card spu-package">
                <div class="spu-card-head">
                    <div class="spu-card-title-wrap">
                        <img class="spu-card-icon" :src="iconPackage" alt="" />
                        <span class="spu-card-title">开通套餐</span>
                    </div>
                </div>
                <div
                    class="spu-package-item"
                    :class="{ active: item.is_recommend }"
                    v-for="(item, i) in package_list"
                    :key="'package_' + i"
                    @click="onSelectPackage(item)"
                >
                    <div class="spu-package-name">
                        <span class="spu-package-name-text">{{ item.name }}</span>
                        <span class="spu-package-badge" v-if="item.is_recommend">推荐</span>
                    </div>
                    <div class="spu-package-price">
                        <div class="spu-package-price-center">
                            <span class="spu-package-price-symbol">¥</span>
                            <span class="spu-package-price-num">{{ item.price }}</span>
                        </div>
                        <div class="spu-package-price-center">
                            <span class="spu-package-price-origin">原价¥{{ item.origin_price }}</span>
                        </div>
                    </div>
                    <div class="spu-package-gift" v-if="item.gift">
                        <img class="spu-package-coin" :src="iconCoin" alt="" />
                        <span class="spu-package-gift-text">{{ item.gift }}</span>
                    </div>
                    <img class="spu-package-corner" :src="iconCorner" alt="" />
                </div>
                <div class="spu-package-activity" v-if="activity_text">
                    <img class="spu-card-icon" :src="iconActivity" alt="" />
                    <span class="spu-package-activity-text">{{ activity_text }}</span>
                </div>
            </div>

            <!-- 客服卡 -->
            <div class="spu-card spu-service" @click="onService">
                <img class="spu-card-icon" :src="iconService" alt="" />
                <span class="spu-service-text">有疑问？联系在线客服</span>
                <img class="spu-card-arrow" :src="arrowService" alt="" />
            </div>

            <!-- 风险提示 -->
            <p class="spu-risk">风险提示：股票池是基于行情数据和K线形态筛选自动生成，仅供参考，不构成操作建议。</p>
        </div>

        <!-- 吸底按钮 -->
        <div class="spu-footer">
            <div class="spu-pay-btn" @click="onPay">
                <span class="spu-pay-symbol">¥</span>
                <span class="spu-pay-num">{{ pay_price }}</span>
                <span class="spu-pay-text">开通查看股票池</span>
            </div>
        </div>

        <!-- 去 App 登录提示弹窗 -->
        <div class="download_app_pop" v-if="toastVisible" @click="toastVisible = false">
            <div class="download_app_content2" @click.stop>
                <p>需要前往app登录才能继续<span>查看</span></p>
                <div class="download_btn_wrap">
                    <a href="javascript:;" class="download_btn_l" @click="toastVisible = false">
                        取消
                    </a>
                    <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui" class="download_btn_r">
                        立即跳转
                    </a>
                </div>
            </div>
        </div>

        <!-- 入选详情弹窗（沿用现有战绩弹窗） -->
        <div class="tanc_w" v-show="show_tip">
            <div class="tanc">
                <svg @click="show_tip = false;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4.63402 4.3513L15.9314 15.6487M4.06833 15.6487L15.3657 4.3513" stroke="#888888" stroke-width="1.6" stroke-linecap="round"/>
                </svg>
                <p class="tanc_fb margin8">{{show_data.stock_name}}（{{show_data.symbol}}）</p>
                <p class="margin8">现价：<span class="tanc_red">{{show_data.last_price}}  +{{show_data.chg_pct}}%</span> </p>
                <p class="margin8">30天入选：<span class="tanc_red">{{show_data.select_number}}次</span> </p>
                <div class="ckhq tanc_red2" @click="goDetail({
                    code: show_data.code,
                    name: show_data.stock_name,
                })">
                    查看行情
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none">
                        <path d="M1.37971 9.82031L5.62028 5.37953L1.37971 1.17969" stroke="#FF443D" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="rxls">
                    <div class="r_l"></div>
                    <span class="tanc_fb span">入选历史</span>
                    <div class="r_l"></div>
                </div>

                <div class="rxls_box">
                    <div class="rxls_item">
                        <span class="tanc_c63">入选时间</span>
                        <span class="tanc_c63">历史推荐</span>
                    </div>
                    <div class="rxls_item" v-for="(item, i) in show_data.list" :key="'history_' + i">
                        <span>{{item.date_ymd}}</span>
                        <span class="tanc_b" @click="showHistory(item);">
                            {{ not_vip && dateStr.includes(item.date_ymd) ? '开通后查看' : '查看' }}
                        </span>
                    </div>
                </div>

                <div class="kt_btn" v-if="not_vip" @click="openPay">
                    立即开通
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

// 设计稿图片资源（AI 透明背景图 + 彩色图标）
const backIcon = require('@/assets/images/stockPool/unlock/back.svg');
const heroImg = require('@/assets/images/stockPool/unlock/hero.png');
const titleImg = require('@/assets/images/stockPool/unlock/title.svg');
const iconRecord = require('@/assets/images/stockPool/unlock/icon-record.svg');
const iconDynamic = require('@/assets/images/stockPool/unlock/icon-dynamic.svg');
const iconPackage = require('@/assets/images/stockPool/unlock/icon-package.svg');
const iconActivity = require('@/assets/images/stockPool/unlock/icon-activity.svg');
const iconService = require('@/assets/images/stockPool/unlock/icon-service.svg');
const iconCoin = require('@/assets/images/stockPool/unlock/icon-coin.svg');
const iconCorner = require('@/assets/images/stockPool/unlock/icon-corner.svg');
const arrowMore = require('@/assets/images/stockPool/unlock/arrow-more.svg');
const arrowService = require('@/assets/images/stockPool/unlock/arrow-service.svg');
const divider1 = require('@/assets/images/stockPool/unlock/divider-1.svg');
const divider2 = require('@/assets/images/stockPool/unlock/divider-2.svg');
const divider3 = require('@/assets/images/stockPool/unlock/divider-3.svg');
const dividerDynamic = require('@/assets/images/stockPool/unlock/divider-dynamic.svg');

export default {
    name: "stockPoolUnlock",
    data() {
        return {
            // 图片资源
            backIcon, heroImg, titleImg,
            iconRecord, iconDynamic, iconPackage, iconActivity, iconService,
            iconCoin, iconCorner, arrowMore, arrowService,
            divider1, divider2, divider3, dividerDynamic,

            // 是否 H5 落地（分享链接）：无 Authorization 参数即落地，需先拿登录态
            isH5: false,
            // 是否已登录（H5 模式下通过 H5ReactUserCenter 判断）
            isLogin: false,
            // 请求头 token：内嵌模式从 query 读取，H5 模式登录后拼接 Bearer
            Authorization: this.getQueryVariable('Authorization') ? decodeURI(this.getQueryVariable('Authorization')) : '',
            // 战绩榜数据
            top_list: [],
            swiper2: null,
            // 战绩轮播当前索引（loop 模式下用 realIndex），「更多」查看当前轮播到的那条
            currentRecordIndex: 0,
            // 购买动态轮播实例
            swiper3: null,
            // 接口返回的最新日期（用于「开通后查看」判断）
            dateStr: '',
            // 去 App 登录提示弹窗
            toastVisible: false,
            // 入选详情弹窗
            show_tip: false,
            show_data: {},
            not_vip: false,
            // 是否已购买（is_vip == "yes" 已购买，否则未购买）
            is_vip: '',

            // ===== 页面数据 =====
            // 购买动态（单行滚动）：接口 get_stock_pool_buy_record
            dynamic_list: [],
            // 开通套餐（多套餐，默认选推荐）：接口 get_stock_pool_product_details
            package_list: [],
            // 限时活动文案（后台配置，无则不显示）
            activity_text: '',
            // 吸底按钮金额（取推荐套餐价格）
            pay_price: 0,
            // 当前选中的套餐
            selected_package: null,
        }
    },
    computed: {
        // 环境前缀：dev/beta/正式
        envPre() {
            let host = location.host;
            if (host.indexOf('dev') != -1 || host.indexOf('192.168.1.107') != -1){
                return 'dev';
            } else if (host.indexOf('beta') != -1) {
                return 'beta';
            }
            return '';
        }
    },
    created() {
        // 内嵌（带 Authorization）直接拉数据；落地（无 Authorization）先拿登录态
        if (this.Authorization) {
            this.isH5 = false;
            this.get_dateStr();
            // 产品详情（套餐 + 活动文案 + 吸底金额）
            this.getProductDetails();
            // 购买记录（购买动态）
            this.getBuyRecord();
        } else {
            this.isH5 = true;
            this.getLoginInfo();
        }
    },
    methods: {
        getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) { return pair[1]; }
            }
            return '';
        },
        // 落地页：拿登录态，取 user_app_token 拼 Bearer
        getLoginInfo() {
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'get',
                dataType: 'json',
                url: `https://mobile${_this.envPre}.aigupiao.com/H5ReactUserCenter/index?Agp-Super-Project=1`,
                cache: false,
                async: true,
                error: function () { return false; },
                success: function (res) {
                    if (res.data && res.data.user_app_token) {
                        _this.isLogin = true;
                        _this.Authorization = "Bearer " + res.data.user_app_token;
                    }
                    _this.get_dateStr();
                    // 产品详情（套餐 + 活动文案 + 吸底金额）
                    _this.getProductDetails();
                    // 购买记录（购买动态）
                    _this.getBuyRecord();
                }
            })
        },
        // 主数据：判断是否 VIP，VIP 直接跳购买后列表页
        get_dateStr() {
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'post',
                dataType: 'json',
                url: `https://app${_this.envPre}.aigupiao.com/goapi/stock/get_stock_pool`,
                cache: false,
                async: true,
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", _this.Authorization);
                },
                error: function () { return false; },
                success: function (res) {
                    _this.dateStr = res.data && res.data.update_time;
                    _this.is_vip = res.data && res.data.is_vip;
                    if (res.data && res.data.is_vip == "yes") {
                        location.href = "/up/h5/stockPool";
                        return;
                    }
                },
                complete: function () {
                    _this.getTopData();
                    if(window.__hideSPLoading) {
                        window.__hideSPLoading();
                    } else {
                        let _loading = document.getElementsByClassName("w_page-loading")[0]
                        _loading.style.display = "none"
                    }
                }
            })
        },
        // 战绩榜轮播信息
        getTopData() {
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'get',
                dataType: 'json',
                url: `https://app${_this.envPre}.aigupiao.com/goapi/stock/stock_pool_rank`,
                // url: `https://api${_this.envPre}.stock-ring.com/goapi/stock/stock_pool_rank`,
                cache: false,
                async: true,
                error: function () { return false; },
                success: function (res) {
                    _this.top_list = res.data || [];
                    _this.swiper();
                }
            })
        },
        // 产品详情：套餐列表 + 活动文案 + 吸底按钮金额
        getProductDetails() {
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'get',
                dataType: 'json',
                url: `https://app${_this.envPre}.aigupiao.com/goapi/stock/get_stock_pool_product_details`,
                cache: false,
                async: true,
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", _this.Authorization);
                },
                error: function () { return false; },
                success: function (res) {
                    if (res.code != 1 || !res.data) return;
                    // 活动文案（无则不显示）
                    _this.activity_text = res.data.activity_text || '';
                    // 套餐列表：映射为页面字段
                    _this.package_list = (res.data.amount_arr || []).map(item => ({
                        product_id: item.product_id,
                        name: item.pro_end_type,
                        price: Number(item.pro_price) || 0,
                        origin_price: Number(item.original_price) || 0,
                        gift: item.gold_give,
                        is_recommend: item.recommend == 'yes',
                        // 服务期限标识（quarter/month/year...），跳转支付时传给 APP
                        pro_end: item.pro_end,
                    }));
                    // 默认选中推荐套餐，吸底按钮金额取推荐套餐价格
                    _this.selected_package = _this.package_list.find(item => item.is_recommend) || _this.package_list[0] || null;
                    if (_this.selected_package) {
                        _this.pay_price = _this.selected_package.price;
                    }
                }
            })
        },
        // 购买记录：购买动态（单行滚动）
        getBuyRecord() {
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'get',
                dataType: 'json',
                url: `https://app${_this.envPre}.aigupiao.com/goapi/stock/get_stock_pool_buy_record`,
                cache: false,
                async: true,
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", _this.Authorization);
                },
                error: function () { return false; },
                success: function (res) {
                    if (res.code != 1 || !res.data) return;
                    // 映射为购买动态文案：昵称后端已脱敏，时间转相对时间
                    _this.dynamic_list = (res.data || []).map(item => ({
                        text: `${item.nickname}${_this.formatRelativeTime(item.purchase_time)}开通了趋势精选股票池`,
                    }));
                    // 初始化购买动态轮播
                    _this.swiperDynamic();
                }
            })
        },
        // 时间戳字符串转相对时间（刚刚/X分钟前/X小时前/X天前）
        formatRelativeTime(timeStr) {
            if (!timeStr) return '';
            const target = new Date(timeStr.replace(/-/g, '/')).getTime();
            if (isNaN(target)) return '';
            const diff = Date.now() - target;
            const minute = 60 * 1000;
            const hour = 60 * minute;
            const day = 24 * hour;
            if (diff < minute) return '刚刚';
            if (diff < hour) return Math.floor(diff / minute) + '分钟前';
            if (diff < day) return Math.floor(diff / hour) + '小时前';
            if (diff < 30 * day) return Math.floor(diff / day) + '天前';
            return '';
        },
        swiper() {
            // 战绩回顾 卡内滚动事件
            if (this.swiper2) {
                // 清除已有滚动
                this.swiper2.destroy(true);
            }
            const records = this.top_list;
            if (records.length > 1) {
                this.$nextTick(() => {
                    this.swiper2 = new Swiper(".spu-record-list .swiper-container", {
                        observer: true,
                        observeParents: true,
                        autoplay: {
                            delay: 3000,
                            disableOnInteraction: false,
                        },
                        loop: true,
                        direction: 'vertical',
                        on: {
                            // 记录当前轮播到的真实索引（loop 模式用 realIndex）
                            slideChange: () => {
                                if (this.swiper2) {
                                    this.currentRecordIndex = this.swiper2.realIndex;
                                }
                            },
                        },
                    });
                });
            }
        },
        // 购买动态 单行滚动
        swiperDynamic() {
            if (this.swiper3) {
                this.swiper3.destroy(true);
            }
            if (this.dynamic_list.length > 1) {
                this.$nextTick(() => {
                    this.swiper3 = new Swiper(".spu-dynamic-list .swiper-container", {
                        observer: true,
                        observeParents: true,
                        autoplay: {
                            delay: 3000,
                            disableOnInteraction: false,
                        },
                        loop: true,
                        direction: 'vertical',
                    });
                });
            }
        },
        // 点击轮播里的战绩股
        onClickRecord(item) {
            // TODO: 接真实战绩弹窗（沿用 openDetail 接口 get_stock_pool_detail）
            if (item.code && this.Authorization) {
                this.openDetail(item.code);
            }
        },
        // 更多 -> 查看当前轮播到的那条战绩详情
        onMoreRecord() {
            const item = this.top_list[this.currentRecordIndex];
            if (item) {
                this.onClickRecord(item);
            }
        },
        // 选择套餐
        onSelectPackage(item) {
            this.selected_package = item;
            this.pay_price = item.price;
        },
        // 联系客服：通知 app 展示右上角客服入口（参考 agpPay.vue）
        onService() {
            this.$srGoToLetterMsg(1205267);
        },
        // 吸底按钮：开通并查看 → 通知 app 跳转趋势精选支付
        onPay() {
            // 通知 app 跳转趋势精选支付（method_name: qsjx_zf_pay）
            // pro_end 为当前选中套餐的服务期限标识（来自 get_stock_pool_product_details 接口的 amount_arr[].pro_end）
            // 说明：授权弹窗由客户端在支付跳转时自行判断，前端无需处理
            if (this.selected_package && this.selected_package.pro_end) {
                this.$srH5CallNativeMethodApp('qsjx_zf_pay', {
                    pro_end: this.selected_package.pro_end,
                    show_loading: 'no'
                });
            } else {
                console.warn('[stockPool unlock] 未选中套餐或缺少 pro_end 参数', this.selected_package);
            }
        },
        // 返回
        onBack() {
            if (window.history.length > 1) {
                window.history.back();
            } else {
                location.href = '/';
            }
        },
        // 点击解锁按钮（旧逻辑保留，供 onPay 迁移参考）
        unlock() {
            if (this.isH5) {
                if (this.isLogin) {
                    if (this.is_vip == "yes") {
                        location.href = "/up/h5/stockPool";
                    } else {
                        this.toastVisible = true;
                    }
                } else {
                    location.href = "/login/index/rd/980880418.html?redirect=" + encodeURIComponent(location.href);
                }
                return;
            }
            let _str = "_str=stockPool#AiGuPiao_ThirdPay";
            if (location.href.indexOf('?') > -1) {
                location.href += ('&' + _str);
            } else {
                location.href += ('?' + _str);
            }
        },
        // 点击轮播里的股票（旧接口保留）
        onClickStock(item) {
            if (this.Authorization) {
                this.openDetail(item.code);
            } else {
                location.href = `http://quote.aigupiao.com/stock_m.php#AiGuPiao_StockCode=${item.code}&name=${item.name}`;
            }
        },
        // 股票详情弹窗数据
        openDetail(stock) {
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: 'get',
                dataType: 'json',
                url: `https://app${_this.envPre}.aigupiao.com/goapi/stock/get_stock_pool_detail`,
                cache: false,
                async: true,
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", _this.Authorization);
                },
                data: { stock: stock },
                error: function () { return false; },
                success: function (res) {
                    if (res.code == 1) {
                        _this.show_tip = true;
                        _this.show_data = res.data;
                        _this.not_vip = res.data.is_vip == 'no' ? true : false;
                        _this.show_data.code = stock;
                    }
                }
            })
        },
        // 跳转行情详情页
        goDetail(item) {
            location.href = `http://quote.aigupiao.com/stock_m.php#AiGuPiao_StockCode=${item.code}&name=${item.name}`;
        },
        showHistory(item) {
            // 判断日期是否是最新时间
            if (this.not_vip && this.dateStr.includes(item.date_ymd)) {
                this.openPay();
            } else {
                this.checkDate(item.date_ymd);
            }
        },
        // 跳转购买后列表页（查看历史）
        checkDate(date) {
            this.show_tip = false;
            location.href = `/up/stockPool?Authorization=${this.Authorization}&kind=QSJX&date=${date}`;
        },
        // 立即开通（支付）
        openPay() {
            this.onPay();
            /* let _str = "_str=stockPool#AiGuPiao_ThirdPay";
            if (location.href.indexOf('?') > -1) {
                location.href += ('&' + _str);
            } else {
                location.href += ('?' + _str);
            } */
        }
    }
}
</script>

<style scoped lang="scss">
.spu-page {
    min-height: 100vh;
    position: relative;
    background: linear-gradient(180deg, #FFF3E8 0%, #FFF8F3 30%, #F8F6F4 100%);
    box-sizing: border-box;
    padding-bottom: 74px;
    overflow: hidden;
}

/* ===== 头图区 ===== */
.spu-hero {
    position: relative;
    height: 180px;
}

.spu-hero-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 180px;
    // background: linear-gradient(180deg, rgba(255, 248, 243, 0) 0%, rgba(255, 248, 243, 0) 75%, #FFF8F3 100%), linear-gradient(90deg, #FFFAF6 0%, #FFF0E3 50%, #FFDCC2 100%);

    img {
        width: 100%;
        height: auto;
        display: block;
        transform: translateY(-20px);
    }
}

.spu-hero-glow {
    position: absolute;
    right: -31px;
    top: -21px;
    width: 240px;
    height: 200px;
    border-radius: 9999px;
    background: radial-gradient(ellipse 50% 50% at 50% 50%, rgba(255, 178, 122, 0.55) 0%, rgba(255, 199, 157, 0.28) 55%, rgba(255, 217, 191, 0) 100%);
}

.spu-hero-main {
    position: absolute;
    right: 4px;
    top: 7px;
    width: 150px;
    height: 141px;
}

.spu-hero-title {
    position: absolute;
    left: 20px;
    top: 25px;
    width: 184px;
    height: 39px;
}

.spu-hero-content {
    
    position: absolute;
    left: 20px;
    top: 75px;
    font-size: 15px;
    color: #8A4B1F;
}

.spu-hero-tags {
    position: absolute;
    left: 20px;
    top: 105px;
    height: 24px;
    background: #FFE6D3;
    border-radius: 12px;
    display: flex;
    align-items: center;
    padding: 0 8px;
}

.spu-hero-tag {
    font-size: 12px;
    color: #E8590C;
}

.spu-hero-divider {
    width: 1px;
    height: 10px;
    margin: 0 6px;
}

/* ===== 内容区 ===== */
.spu-body {
    position: relative;
    padding: 0 16px;
    transform: translateY(-30px);
}

.spu-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(255, 122, 45, 0.08);
    margin-bottom: 12px;
    box-sizing: border-box;
}

.spu-card-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}

.spu-card-title-wrap {
    display: flex;
    align-items: center;
}

.spu-card-title {
    font-size: 15px;
    font-weight: 500;
    color: #222;
    margin-left: 6px;
}

.spu-card-sub {
    font-size: 12px;
    color: #BBB;
    margin-left: 6px;
}

.spu-card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.spu-card-more {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.spu-card-more span {
    font-size: 12px;
    color: #999;
}

.spu-card-arrow {
    width: 5px;
    height: 10px;
    margin-left: 3px;
}

/* ===== 介绍文案卡 ===== */
.spu-intro {
    padding: 14px 12px;
}

.spu-intro-text {
    font-size: 12px;
    line-height: 18px;
    color: #555;
    word-break: break-all;
}

.spu-intro-text em {
    font-style: normal;
    color: #FF5A1F;
    font-weight: 500;
}

/* ===== 战绩回顾卡 ===== */
.spu-record {
    padding: 14px 12px 14px;
    overflow: hidden;
}

.spu-record-list {
    margin-top: 8px;
    height: 24px;
    border-radius: 8px;
    overflow: hidden;
}

.spu-record-list .swiper-container {
    height: 100%;
}

.spu-record-list .swiper-slide {
    height: 24px;
    display: flex;
    align-items: center;
    overflow: hidden;
}

.spu-record-name {
    font-size: 15px;
    font-weight: 500;
    color: #222;
    flex-shrink: 0;
}

.spu-record-desc {
    font-size: 13px;
    color: #666;
    margin-left: 8px;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.spu-record-pct {
    font-size: 18px;
    font-weight: 500;
    color: #EA3732;
    margin-left: 12px;
    flex-shrink: 0;
}

.spu-record-pct.down {
    color: #00A05E;
}

/* ===== 购买动态卡 ===== */
.spu-dynamic {
    display: flex;
    align-items: center;
    height: 40px;
    padding: 0 12px;
}

.spu-dynamic-label {
    font-size: 13px;
    font-weight: 500;
    color: #FF5A1F;
    margin-left: 6px;
    flex-shrink: 0;
}

.spu-dynamic-divider {
    width: 1px;
    height: 12px;
    margin: 0 7px;
    flex-shrink: 0;
}

.spu-dynamic-list {
    flex: 1;
    height: 40px;
    overflow: hidden;
}

.spu-dynamic-list .swiper-container {
    height: 100%;
}

.spu-dynamic-list .swiper-slide {
    height: 40px;
    display: flex;
    align-items: center;
    overflow: hidden;
}

.spu-dynamic-text {
    font-size: 13px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ===== 开通套餐卡 ===== */
.spu-package {
    padding: 14px 12px 12px;
}

.spu-package-item {
    position: relative;
    margin-top: 12px;
    height: 64px;
    border-radius: 10px;
    background: #FFF5F0;
    display: flex;
    align-items: center;
    padding: 0 0 0 10px;
    cursor: pointer;
    box-sizing: border-box;
    border: 1px solid transparent;
}

.spu-package-item.active {
    border-color: #FF5A1F;
}

.spu-package-name {
    display: flex;
    align-items: center;
    width: unset;
    flex-shrink: 0;
}

.spu-package-name-text {
    font-size: 17px;
    font-weight: 700;
    color: #222;
    white-space: nowrap;
}

.spu-package-badge {
    margin-left: 6px;
    height: 18px;
    line-height: 18px;
    padding: 0 5px;
    background: #FD3632;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    border-radius: 4px;
    white-space: nowrap;
}

.spu-package-price {
    display: flex;
    align-items: baseline;
    margin-left: 13px;
    width: 58px;
    flex-shrink: 0;
    flex-wrap: wrap;

    .spu-package-price-center {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;

        .spu-package-price-symbol {
            font-size: 13px;
            font-weight: 700;
            color: #EA3732;
        }

        .spu-package-price-num {
            font-size: 24px;
            font-weight: 700;
            color: #EA3732;
            margin-left: 2px;
        }

        .spu-package-price-origin {
            font-size: 12px;
            color: #AAA;
            width: 100%;
            text-decoration: line-through;
            white-space: nowrap;
        }
    }
}

.spu-package-gift {
    display: flex;
    align-items: center;
    height: 24px;
    padding: 0 10px;
    background: #FDEFD9;
    border-radius: 4px;
    margin-left: 10px;

    .spu-package-coin {
        width: 16px;
        height: 16px;
    }

    .spu-package-gift-text {
        font-size: 13px;
        font-weight: 500;
        color: #FE4A14;
        margin-left: 4px;
    }
}

.spu-package-corner {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 22px;
    height: 22px;
}

.spu-package-activity {
    display: flex;
    /* 顶部对齐 + 首行行高与图标等高，保证首行文字与图标垂直居中，换行后逐行下延 */
    align-items: flex-start;
    margin-top: 12px;
}

.spu-package-activity-text {
    flex: 1;
    min-width: 0;
    font-size: 14px;
    line-height: 20px;
    color: #824225;
    margin-left: 6px;
    word-break: break-word;
}

/* ===== 客服卡 ===== */
.spu-service {
    display: flex;
    align-items: center;
    height: 44px;
    padding: 0 12px;
    cursor: pointer;
}

.spu-service-text {
    flex: 1;
    font-size: 13px;
    color: #333;
    margin-left: 8px;
}

/* ===== 风险提示 ===== */
.spu-risk {
    font-size: 12px;
    color: #999;
    line-height: 18px;
    padding: 4px 0;
}

/* ===== 吸底按钮 ===== */
.spu-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 63px;
    background: #fff;
    border-top: 0.5px solid #F0EBE7;
    z-index: 50;
}

.spu-pay-btn {
    position: absolute;
    left: 16px;
    top: 9px;
    width: calc(100% - 32px);
    height: 44px;
    border-radius: 22px;
    background: linear-gradient(90deg, #FF7A3D 0%, #FF3D1F 100%);
    box-shadow: 0 4px 10px rgba(255, 77, 31, 0.28);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.spu-pay-symbol {
    font-size: 14px;
    font-weight: 700;
    color: #fff;
}

.spu-pay-num {
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    margin-left: 2px;
}

.spu-pay-text {
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    margin-left: 6px;
}

/* ===== 入选详情弹窗（沿用现有） ===== */
.tanc_w {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 20px;
    color: #333;
}

.tanc {
    width: 265px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 3px solid #EDD8A9;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 100%), linear-gradient(180deg, #F7E4C8 0%, #FFF 44.33%);
    padding: 24px;
    box-sizing: border-box;
    position: relative;
}

.tanc > svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    position: absolute;
    top: 16px;
    right: 16px;
}

.tanc_red {
    color: #CB382D;
}

.tanc_red2 {
    color: #FF443D;
}

.tanc_c63 {
    color: #636363;
}

.tanc_b {
    color: #1D88D0;
}

.tanc_fb {
    font-weight: bold;
}

.ckhq {
    display: flex;
    width: 220px;
    height: 31px;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
    flex-shrink: 0;
    border-radius: 21px;
    border: 1px solid #FF443D;
}

.ckhq > svg {
    width: 6px;
    height: 12px;
    flex-shrink: 0;
    margin-left: 6px;
}

.margin8 {
    margin-bottom: 8px;
}

.rxls {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 17px 0;
}

.tanc_fb.span {
    margin: 0 10px;
}

.r_l {
    width: 50px;
    height: 1px;
    background: #EBEBEB;
}

.rxls_item {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.kt_btn {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    height: 36px;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
    flex-shrink: 0;
    border-radius: 21px;
    background: linear-gradient(180deg, #EB8057 0%, #EC5E3A 100%);
    color: #FFF;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.download_app_pop {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .3);
}

.download_app_content2 {
    border-radius: 11px;
    background: #FFF;
    display: flex;
    width: 252px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.download_app_content2 > p {
    color: #333;
    font-size: 15px;
    padding: 18px 14px;
    line-height: 1.5;
}

.download_btn_wrap {
    display: flex;
    width: 100%;
    border-top: 0.5px solid #EBEBEB;
}

.download_btn_wrap > a {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #636363;
    font-size: 14px;
    height: 41px;
    width: 50%;
}

.download_btn_wrap .download_btn_r {
    color: #FE484A;
    border-left: 0.5px solid #EBEBEB;
}
</style>
